// Layar masuk, beranda (pilih mapel), dan pengaturan ronde.
import { $, $$ } from '../core/dom.js';
import { esc } from '../core/format.js';
import { store } from '../core/storage.js';
import { muatKonten } from '../content/muat.js';
import { S, panggil } from './state.js';
import { show } from './screens.js';
import { mascot } from './mascot.js';
import { sfx } from './sound.js';
import { cekSesi, masuk, keluar } from './sesi.js';
import { mulaiKuis } from './kuis.js';
import { bukaSemuaRumus } from './rumus.js';
import { tampilkanHasil } from './hasil.js';
import { daftarRiwayat, ambilRiwayat, kirimAntrean } from './riwayat.js';
import { pemilihTema, hubungkanPemilih } from './tema.js';
import { modal, modalLebar, closeModal, toast } from './modal.js';
import { fmtDur } from '../core/format.js';
import { tombolPasang } from './pwa.js';
import { keBelajar, daftarModul, ringkasProgres } from '../belajar/mesin.js';
import { pasangKartuHariIni, pasangKostum, rayakan } from '../game/ui.js';
import { sinkron, isiAwal } from '../game/profil.js';
import { pasangPromo, promoPertamaKali } from './promo.js';

async function siapkanKonten() {
  S.konten = await muatKonten();
  const k = S.konten.config.kuis;
  if (!k.pilihanJumlahSoal.includes(S.jumlah)) S.jumlah = k.jumlahSoalAwal;
}

export function keBeranda() {
  $('#home-hi').textContent = `Halo, ${S.nama}!`;
  pasangKostum();
  $('#home-mascot').innerHTML = mascot('happy', 96);
  pasangKartuHariIni($('#gm-hari-ini'));
  rayakan({ tunda: 600 });
  $('#offline-pill').hidden = !S.offline && navigator.onLine !== false;
  $('#subjects').innerHTML = S.konten.config.mapel.map(m => m.aktif
    ? `<button class="subj subj-on" data-mapel="${esc(m.id)}" type="button"><span class="glyphs" aria-hidden="true">${esc(m.simbol)}</span><h3>${esc(m.nama)}</h3><span>${esc(m.keterangan)}</span></button>`
    : `<div class="subj subj-off" aria-disabled="true"><span class="glyphs" aria-hidden="true">${esc(m.simbol)}</span><h3>${esc(m.nama)}</h3><span class="pill">${esc(m.keterangan || 'Segera hadir')}</span></div>`).join('');
  $$('[data-mapel]').forEach(b => b.onclick = () => { S.mapel = b.dataset.mapel; sfx.tap(); keSetup(); });
  // Kartu belajar: mapel yang sudah punya modul bisa dibuka, sisanya "Segera hadir".
  $('#subjects-belajar').innerHTML = S.konten.config.mapel.map(m => {
    if (!daftarModul(m.id).length) return `<div class="subj subj-off subj-kecil" aria-disabled="true"><span class="glyphs" aria-hidden="true">${esc(m.simbol)}</span><h3>${esc(m.nama)}</h3><span class="pill">Segera hadir</span></div>`;
    const p = ringkasProgres(m.id);
    return `<button class="subj subj-on subj-kecil subj-belajar" data-belajar="${esc(m.id)}" type="button"><span class="glyphs" aria-hidden="true">${esc(m.simbol)}</span><h3>Belajar ${esc(m.nama)}</h3><span>${p.total} modul interaktif · ${p.selesai} selesai</span><span class="subj-prog" aria-hidden="true"><i style="width:${p.total ? Math.round(p.selesai / p.total * 100) : 0}%"></i></span></button>`;
  }).join('');
  $$('[data-belajar]').forEach(b => b.onclick = () => { S.mapel = b.dataset.belajar; sfx.tap(); keBelajar(b.dataset.belajar); });
  tombolPasang($('#btn-install'));
  show('home');
}

// Keterangan ronde & cara belajar dari salah, per mapel.
const TEKS_SETUP = {
  matematika: {
    desc: 'Setiap ronde berisi soal baru dengan angka yang berbeda. Bentuk soalnya seperti TKA: pilihan ganda, Benar/Salah, dan pilih lebih dari satu jawaban.',
    salah: 'Kalau salah, muncul cara hitung langkah demi langkah.',
  },
  'bahasa-indonesia': {
    desc: 'Setiap ronde berisi teks informasi dan teks fiksi, masing-masing dengan beberapa soal, seperti TKA. Bentuk soalnya: pilihan ganda, pilihan ganda kompleks, dan Benar/Salah.',
    salah: 'Kalau salah, bukti di teks disorot dan setiap pilihan dijelaskan alasannya.',
  },
};

export function keSetup() {
  const m = S.konten.config.mapel.find(x => x.id === S.mapel), k = S.konten.config.kuis;
  const ts = TEKS_SETUP[m.id] || TEKS_SETUP.matematika;
  $('#setup-desc').textContent = ts.desc;
  $('#fact-salah-sub').textContent = ts.salah;
  $('#setup-mapel').textContent = m.nama;
  $('#fact-pass').textContent = `Batas lulus ${k.batasLulus}`;
  $('#fact-pass-sub').textContent = `Nilai di bawah ${k.batasLulus} belum lulus.`;
  $('#fact-pass-dot').textContent = k.batasLulus;
  const label = ['santai', 'seru', 'juara', 'jagoan', 'super'];
  $('#counts').innerHTML = k.pilihanJumlahSoal.map((n, i) => `<button class="count" role="radio" aria-checked="${n === S.jumlah}" data-n="${n}" type="button"><b>${n}</b><span>soal · ${label[i] || 'tantangan'}</span></button>`).join('');
  $$('#counts .count').forEach(b => b.onclick = () => { S.jumlah = +b.dataset.n; $$('#counts .count').forEach(x => x.setAttribute('aria-checked', x === b)); sfx.tap(); });
  const rumus = S.konten.rumus[S.mapel] || [];
  $('#btn-rumus').hidden = !rumus.length;
  const bank = (S.konten.bank[S.mapel] || []).length;
  $('#bank-info').textContent = bank ? `Ronde ini juga memuat soal pilihan guru dari bank soal (${bank} soal tersedia).` : '';
  $('#setup-title').innerHTML = `Siap, ${panggil()}? Mau berapa soal di ronde ini?`;
  show('setup');
  muatDaftarRiwayat();
}

async function masukKe(nama, offline, akun) {
  S.nama = nama; S.akun = akun || ''; S.offline = !!offline;
  await siapkanKonten();
  keBeranda();
  kirimAntrean().then(n => { if (n) toast(`${n} hasil latihan yang tertunda sudah tersimpan di riwayat.`); });
  // Profil gamifikasi: gabung dengan salinan server, lalu (sekali) isi dari riwayat lama.
  sinkron().then(() => isiAwal()).then(n => {
    pasangKostum();
    if (!$('#scr-home').hidden) keBeranda();
    if (n) toast(`${n} hasil latihan sebelumnya ikut dihitung ke Peta Kemampuan dan prestasimu.`);
  });
}

// Perangkat ini sudah dipakai akun lain dengan nama berbeda: ganti nama, atau anak lain?
// (Akun terikat pada perangkat; lihat lib/akun.js.) Mengembalikan id akun, 'baru', atau null.
function tanyaAkun(daftar, namaBaru) {
  const akun = daftar.slice(0, 4), satu = akun.length === 1;
  const sebut = akun.map(a => `<b>${esc(a.nama)}</b>`).join(', ');
  return new Promise(selesai => {
    modal(`${mascot('think', 90).replace('class="mascot ', 'style="margin:0 auto" class="mascot ')}
      <h3>Halo, ${esc(namaBaru)}!</h3>
      <p>Perangkat ini sudah pernah dipakai oleh ${sebut}.</p>
      <p>${satu ? `Kamu <b>${esc(akun[0].nama)}</b> yang mau ganti nama jadi <b>${esc(namaBaru)}</b>?` : `Apakah kamu salah satunya dan mau ganti nama jadi <b>${esc(namaBaru)}</b>?`} Kalau bukan, pilih <b>Aku anak lain</b>.</p>`, [
      ...akun.map(a => ({ label: `Ya, aku ${esc(a.nama)}`, cls: 'btn-sky', on: () => selesai(a.id) })),
      { label: 'Aku anak lain', cls: 'btn-go', on: () => selesai('baru') },
      { label: 'Batal', on: () => selesai(null) },
    ]);
  });
}

// ---------- riwayat ----------
const tglPendek = iso => iso ? new Date(iso).toLocaleString('id-ID', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '–';
const barisRiwayat = x => `<button class="hist-row" type="button" data-hist="${esc(x.id)}"><span>${esc(tglPendek(x.selesai))} · ${x.jumlah} soal · ${fmtDur(x.durasiMs)}</span><span><b>Nilai ${x.nilai}</b> <span class="st ${x.lulus ? 'g' : 'b'}">${x.lulus ? 'Lulus' : 'Belum lulus'}</span>${x.tertunda ? ' <span class="st w">Belum terkirim</span>' : ''}</span></button>`;

async function muatDaftarRiwayat() {
  const card = $('#hist-card'), list = $('#hist-list');
  card.hidden = false;
  list.innerHTML = '<p class="muted" style="font-weight:700">Memuat riwayat...</p>';
  const { riwayat, offline } = await daftarRiwayat(S.mapel);
  if ($('#scr-setup').hidden) return;
  if (!riwayat.length) { list.innerHTML = `<p class="muted" style="font-weight:700">${offline ? 'Riwayat bisa dilihat saat online.' : `Belum ada riwayat. Ayo mulai latihan pertamamu, ${panggil()}!`}</p>`; $('#btn-hist-all').hidden = true; return; }
  list.innerHTML = riwayat.slice(0, 4).map(barisRiwayat).join('') + (offline ? '<p class="muted" style="font-weight:700">Sedang offline, hanya hasil di perangkat ini yang tampil.</p>' : '');
  $('#btn-hist-all').hidden = riwayat.length <= 4;
  $('#btn-hist-all').onclick = () => {
    const m = modalLebar(`<div class="modal-head"><b>Semua riwayat latihan</b><span class="muted" style="font-weight:700">${riwayat.length} latihan</span><span class="grow"></span><button class="btn btn-sm btn-pink" data-close type="button">Tutup</button></div><div class="scroll hist" style="flex:1;min-height:0">${riwayat.map(barisRiwayat).join('')}</div>`, { label: 'Semua riwayat', cls: 'modal-rumus' });
    m.querySelectorAll('[data-hist]').forEach(b => b.onclick = () => { closeModal(); bukaRiwayat(b.dataset.hist); });
  };
  list.querySelectorAll('[data-hist]').forEach(b => b.onclick = () => bukaRiwayat(b.dataset.hist));
}

async function bukaRiwayat(id) {
  toast('Membuka hasil latihan...', { lama: 2000 });
  try {
    const r = await ambilRiwayat(id);
    if (!r) throw new Error('Hasil latihan tidak ditemukan.');
    $('#toast').hidden = true;
    tampilkanHasil(r);
  } catch (e) {
    toast(e.message || 'Gagal memuat hasil latihan. Periksa koneksi internet.');
  }
}

export async function initBeranda() {
  $('#login-mascot').innerHTML = mascot('happy', 150);
  pasangPromo($('#btn-promo'));
  $('#tema-login').innerHTML = pemilihTema();
  hubungkanPemilih($('#tema-login'));
  $('#btn-tema').onclick = () => {
    modal(`${mascot('wow', 90).replace('class="mascot ', 'style="margin:0 auto" class="mascot ')}<h3>Pilih warna tema, ${panggil()}!</h3>${pemilihTema()}`, [{ label: 'Selesai', cls: 'btn-go' }]);
    hubungkanPemilih($('#modal-root'));
  };
  window.addEventListener('online', () => { if (S.nama) kirimAntrean(); });
  $('#in-name').value = store.get('tka-name', '');
  const form = $('#login-form'), err = $('#login-err'), btn = $('#btn-login');
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const nama = $('#in-name').value.trim(), sandi = $('#in-pass').value;
    if (!nama) { err.textContent = 'Tulis namamu dulu, ya.'; err.hidden = false; $('#in-name').focus(); return; }
    btn.disabled = true; btn.textContent = 'Memeriksa...';
    let r = await masuk(nama, sandi);
    if (r.konfirmasi) {
      const pilih = await tanyaAkun(r.konfirmasi, nama);
      r = pilih ? await masuk(nama, sandi, pilih) : { ok: false, pesan: 'Masuk dibatalkan.' };
    }
    btn.disabled = false; btn.textContent = 'Ayo mulai!';
    if (!r.ok) { err.textContent = r.pesan; err.hidden = false; $('#in-pass').select(); sfx.no(); return; }
    err.hidden = true; $('#in-pass').value = ''; store.set('tka-name', nama);
    document.activeElement?.blur();
    await masukKe(r.nama || nama, r.offline, r.akun);
  });
  $('#btn-logout').onclick = async () => { await keluar(); S.nama = ''; S.akun = ''; show('login'); };
  $('#btn-back-home').onclick = keBeranda;
  $('#btn-start').onclick = mulaiKuis;
  $('#btn-rumus').onclick = () => bukaSemuaRumus(S.mapel);

  // Jika cookie sesi masih berlaku, langsung ke beranda.
  const sesi = await cekSesi();
  if (sesi.ok) await masukKe(sesi.nama, sesi.offline, sesi.akun);
  else { show('login'); promoPertamaKali(); }
}
